<template>
    <v-dialog
        v-model="display"
        width="100%"
        max-width="800px"
        :content-class="$vuetify.breakpoint.smAndUp ? 'guestEditDialogDesktop' : 'guestEditDialogMobile'"
        persistent
        scrollable>
        <v-card>
            <v-card-text class="pb-0">
                <v-container v-if="eventMerchant" fluid class="px-0 pb-0 mt-3">
                    <v-label>{{$t('merchant.edit')}}</v-label>
                    <v-form ref="form" v-model="isFormValid">
                        <v-container fluid class="px-0 pb-0">
                            <v-row>
                                <v-col class="pt-3 pb-0">
                                    <v-text-field outlined
                                        label="Username*"
                                        placeholder=" "
                                        v-model="eventMerchant.username"
                                        readonly></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-checkbox class="my-0"
                                        v-model="showPassword"
                                        :label="$t('user.change_password')" >
                                    </v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        :label="$t('user.new_password')"
                                        :placeholder="$t('user.new_password')"
                                        v-model="password"
                                        :rules="passwordRules"
                                        :append-icon="revealPasswordText ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="revealPasswordText ? 'text' : 'password'"
                                        @click:append="revealPasswordText = !revealPasswordText"
                                        v-on:input="changePassword"
                                        v-if="showPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field
                                        outlined
                                        ref="confirmPasswordEle"
                                        :label="$t('user.confirm_password')"
                                        :placeholder="$t('user.confirm_password')"
                                        v-model="confirmPassword"
                                        :rules="confirmPasswordRules"
                                        :append-icon="revealConfirmPasswordText ? 'mdi-eye' : 'mdi-eye-off'"
                                        :type="revealConfirmPasswordText ? 'text' : 'password'"
                                        @click:append="revealConfirmPasswordText = !revealConfirmPasswordText"
                                        v-if="showPassword"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="First Name"
                                        placeholder=" "
                                        v-model="eventMerchant.firstname"
                                        :rules="nameRules"></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Last Name"
                                        placeholder=" "
                                        v-model="eventMerchant.lastname"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Email"
                                        placeholder=" "
                                        v-model="eventMerchant.email"
                                        :rules="emailRules"></v-text-field>
                                </v-col>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Mobile"
                                        placeholder=" "
                                        v-model="eventMerchant.mobile"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col class="py-0">
                                    <v-text-field outlined
                                        label="Remarks"
                                        placeholder=" "
                                        v-model="eventMerchant.remarks"
                                        ></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-container>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="secondary" @click="closeDialog">
                    {{$t('cancel')}}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="saveEventMerchant">
                    {{$t('save')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {computed, ref} from "@vue/composition-api";
    import {useFind, useGet} from "feathers-vuex";

    export default {
        name: 'EventMerchantEdit',
        props: {
            displayGuestEditDialog: Boolean
        },
        setup(props, {root}) {
            const {Merchant} = root.$FeathersVuex.api;
            
            const display = ref(true);
            
            const form = ref(null);
            const isFormValid = ref(false);
            const showPassword = ref(false);
            const password = ref("");
            const confirmPassword = ref("");
            const revealPasswordText = ref(false);
            const revealConfirmPasswordText = ref(false);
            const confirmPasswordEle = ref(null);

            const eventId = computed(() => root.$route.params.eventId);
            const merchantId = computed(() => root.$route.params.merchantId);
            const {item: eventMerchant} = useGet({model: Merchant, id: merchantId});

            const passwordRules = ref([
                value => ((value || '').length == 0 || (value || '').length >= 4) || 'Min 4 characters',
            ]);
            const confirmPasswordRules = ref([
                value => !!value || 'Password Not Match',
                value => (value == password.value) || 'Password Not Match',
            ]);

            const nameRules = ref([
                value => !!value || 'Required',
            ]);

            const emailRules = ref([
                value => /^[^@]+@[^@]+\.[^@]+$/.test(value) || 'Invalid Email formant ',
            ]);

            // const tokenRules = ref([
            //     value => !!value || 'Required',
            // ]);
            
            // const getImageSrc = (obj, field)=>{
            //     if (obj && obj[field]) {
            //         return obj[field].src
            //             ? obj[field].src
            //             : (obj.src ? obj.src : obj[field]);
            //     }
            // }
            // const isImageSrcValid = (obj, field) => {
            //     const objSrc = getImageSrc(obj, field);
            //     return (objSrc && objSrc.includes('http'));
            // }
            // const handleProfilePictureChanged = (e) => {
            //     if (e.ev_profile_pic instanceof File) {
            //         e.src = URL.createObjectURL(e.ev_profile_pic);
            //     } else {
            //         e.src = '';
            //         e.ev_profile_pic = '';
            //     }
            // }
            
            const closeDialog = () => {
                root.$router.replace({name: 'event-merchants'});
            }

            const saveEventMerchant = async () => {
                if (isFormValid.value) {
                    if (!showPassword.value) {
                        delete eventMerchant.value.password;
                    } else {
                        eventMerchant.value.password = password.value;
                    }
                    try {
                        // if (eventMerchant.value.ev_profile_pic instanceof File) {
                        //     eventMerchant.value.ev_profile_pic = {src: await root.$uploadFile(eventMerchant.value.ev_profile_pic)};
                        // }
                        // if (!eventMerchant.value.ev_profile_pic) {
                        //     eventMerchant.value.ev_profile_pic = null;
                        // }

                        await eventMerchant.value.save();
                        
                        root.$store.dispatch('showSnackBar', 'Merchant Saved.');
                        closeDialog();
                    } catch (e) {
                        root.$handleFeatherError(e);
                    }
                } else {
                    form.value.validate();
                }
            };

            const changePassword = () => {
                confirmPasswordEle.value.validate();
            };
            
            return {
                form,
                isFormValid,
                nameRules,
                emailRules,
                // tokenRules,
                saveEventMerchant,
                
                eventMerchant,

                // getImageSrc,
                // isImageSrcValid,
                // handleProfilePictureChanged,

                closeDialog,
                display,

                showPassword,
                password,
                confirmPassword,
                passwordRules,
                confirmPasswordRules,
                revealPasswordText,
                revealConfirmPasswordText,
                changePassword,
                confirmPasswordEle,
            }
        },
    }
</script>